var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 13.8333H22M10.3333 22H29M16.5954 36H31.8C35.7204 36 37.6805 36 39.1779 35.237C40.4951 34.5659 41.5659 33.4951 42.237 32.1779C43 30.6806 43 28.7204 43 24.8V12.2C43 8.27963 43 6.31945 42.237 4.82207C41.5659 3.50493 40.4951 2.43407 39.1779 1.76295C37.6805 1 35.7204 1 31.8 1H12.2C8.27963 1 6.31945 1 4.82207 1.76295C3.50493 2.43407 2.43407 3.50493 1.76295 4.82207C1 6.31945 1 8.27963 1 12.2V41.4495C1 42.6928 1 43.3145 1.25487 43.6338C1.47652 43.9114 1.81263 44.073 2.16793 44.0726C2.57646 44.0722 3.0619 43.6838 4.03277 42.9071L9.59883 38.4543C10.7359 37.5446 11.3044 37.0898 11.9375 36.7664C12.4991 36.4794 13.097 36.2697 13.7148 36.1429C14.4112 36 15.1393 36 16.5954 36Z",
    stroke: "#27AE60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportChatIcon);
export default __webpack_public_path__ + "static/media/support-chat-icon.5daabd60065cd0ecc9c14e2d61b84627.svg";
export { ForwardRef as ReactComponent };